import { HeroButtons } from "./HeroButtons";
import { useLandingSettings, isUsableUrl } from "@/context/LandingSettingsContext";

/**
 * ProphetsFinalCTA — Section 8. Closing statement mirroring the hero
 * language at a smaller scale, with an added tertiary "Join Discord" CTA.
 */
export function ProphetsFinalCTA({ mintHref, marketplaceHref, discordHref }) {
  const { settings } = useLandingSettings();
  const resolvedDiscord = discordHref || settings.discord_url;
  const discordUsable = isUsableUrl(resolvedDiscord);
  return (
    <section
      data-testid="final-cta-section"
      className="prophets-final relative w-full px-5 md:px-10 py-24 md:py-32 overflow-hidden"
    >
      {/* Deep-black base + subtle metallic halo, no full hero duplication. */}
      <div aria-hidden="true" className="prophets-final-halo" />
      <svg
        aria-hidden="true"
        viewBox="0 0 1600 500"
        preserveAspectRatio="xMidYMid slice"
        className="prophets-final-svg"
      >
        <defs>
          <linearGradient id="final-line" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%"   stopColor="rgba(220,228,244,0)" />
            <stop offset="50%"  stopColor="rgba(220,228,244,0.20)" />
            <stop offset="100%" stopColor="rgba(220,228,244,0)" />
          </linearGradient>
        </defs>
        <ellipse cx="800" cy="250" rx="700" ry="140" fill="none" stroke="url(#final-line)" strokeWidth="0.6" />
        <ellipse cx="800" cy="250" rx="520" ry="100" fill="none" stroke="url(#final-line)" strokeWidth="0.55" opacity="0.8" />
        {/* Faint stars */}
        {[[220,120,0.7,0.45],[460,80,0.9,0.55],[720,50,0.7,0.4],[1120,90,0.8,0.5],[1380,140,0.7,0.4],
          [180,420,0.7,0.4],[540,440,0.9,0.5],[900,410,0.7,0.4],[1240,430,0.8,0.5]].map(([x,y,r,o]) => (
          <circle key={`fs-${x}-${y}`} cx={x} cy={y} r={r} fill="#ffffff" opacity={o} />
        ))}
      </svg>

      <div className="relative z-10 mx-auto max-w-[1000px] w-full text-center">
        <h2
          data-testid="final-cta-title"
          className="p-nav prophets-final-title"
        >
          The Future Has Already Been Seen.
        </h2>
        <p className="prophets-final-lede">
          Join the founding collection behind the next generation of community-driven games.
        </p>

        <div className="prophets-final-actions prophets-final-actions--desktop-only">
          <HeroButtons mintHref={mintHref} marketplaceHref={marketplaceHref} />
          {discordUsable ? (
            <a
              href={resolvedDiscord}
              target="_blank"
              rel="noreferrer"
              data-testid="final-cta-discord"
              className="prophets-final-discord p-nav"
            >
              <span>Join Discord</span>
            </a>
          ) : (
            <button
              type="button"
              aria-disabled="true"
              data-testid="final-cta-discord"
              onClick={(e) => e.preventDefault()}
              className="prophets-final-discord p-nav"
              style={{ opacity: 0.45, cursor: "default" }}
            >
              <span>Join Discord</span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
